import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicabservice() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Cab Service',
    heading: 'Sanavi Travels: Pune to Mumbai Cab Service',
    headingDescription: 'Sanavi Travels offers reliable Pune to Mumbai Cab Service, providing safe, comfortable, and hassle-free transportation for families, corporate travelers, business executives, and tourists traveling between Pune and Mumbai. Our fleet of well-maintained sedans, SUVs, and luxury cabs ensures spacious seating, air-conditioning, and ample luggage space for a smooth and relaxed journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering all major Mumbai locations such as Andheri, Bandra, Borivali, Dadar, South Mumbai, Navi Mumbai, Thane, and Mumbai Airport. Choose Sanavi Travels for trusted Pune to Mumbai cab services, delivering comfort, safety, and a seamless intercity travel experience.',

    top: 'Top Places to Visit in Mumbai with Sanavi Travels',


"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India is Mumbai’s most iconic landmark, overlooking the Arabian Sea. Built in 1924, it commemorates the visit of King George V and Queen Mary. Today, it serves as a major tourist attraction and the starting point for ferry rides to Elephanta Caves."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a beautiful seaside boulevard stretching along the Arabian Sea. It is famous for its sunset views, evening walks, and glittering city lights at night. Locals and tourists alike enjoy its relaxing atmosphere."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are ancient rock-cut caves dedicated to Lord Shiva, located on Elephanta Island. A UNESCO World Heritage Site, the caves feature remarkable sculptures, including the famous Trimurti statue. They offer a blend of history, art, and spirituality."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage Site and an architectural marvel blending Victorian Gothic and Indian styles. One of India’s busiest railway stations, it stands as a symbol of Mumbai’s colonial history and vibrant urban life."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular beaches, known for its lively atmosphere, street food, and sunset views. Visitors enjoy local snacks like pav bhaji and bhel puri while relaxing by the sea."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is one of Mumbai’s most revered Hindu temples, dedicated to Lord Ganesha. Devotees from all walks of life visit to seek blessings for success and prosperity. The temple is especially crowded on Tuesdays and during festivals."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a famous Islamic shrine located on an islet in the Arabian Sea. Connected by a narrow causeway, it is visited by people of all faiths. The dargah is admired for its spiritual ambiance and stunning sea views."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a vast green oasis within Mumbai, home to rich wildlife and the ancient Kanheri Caves. Visitors can enjoy safaris, trekking trails, and nature walks, offering a refreshing escape from city life."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel connecting Bandra and Worli. It offers spectacular views of the Mumbai skyline and the Arabian Sea, especially at night."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling shopping street known for fashion, accessories, handicrafts, and cafés. It is a favorite destination for shopping, street food, and experiencing Mumbai’s energetic street culture."
  }
]
,




"services": [
  {
    "name": "Pune to Mumbai Cab Service",
    "description": "Pune to Mumbai Cab Service provides a fast, reliable, and comfortable road travel option between the two major cities. Fully air-conditioned cabs with comfortable seating, smooth ride quality, and ample luggage space make the journey stress-free. Experienced chauffeurs ensure safe driving on highways, punctual pickups, and efficient route planning. Ideal for business travelers, families, tourists, and daily commuters, this service is suitable for one-way trips, round trips, airport transfers, and corporate travel needs."
  },
  {
    "name": "Mumbai Cab from Pune",
    "description": "Mumbai Cab from Pune offers a dependable and convenient solution for travelers heading to Mumbai. Well-maintained, air-conditioned vehicles with professional drivers ensure a smooth and comfortable journey. Flexible pickup and drop locations make this service suitable for hotels, homes, offices, or airports. Perfect for families, corporate travelers, and tourists, it focuses on safety, punctuality, and comfort."
  },
  {
    "name": "AC Cab Pune to Mumbai",
    "description": "AC Cab Pune to Mumbai ensures a cool and relaxing journey, especially during peak travel hours and summer seasons. Fully air-conditioned cabs provide spacious seating, smooth suspension, and comfortable interiors. Skilled chauffeurs manage traffic and highway driving efficiently, making this service ideal for families, solo travelers, and corporate passengers seeking comfort and reliability."
  },
  {
    "name": "Luxury Cab Mumbai Trip",
    "description": "Luxury Cab Mumbai Trip offers a premium travel experience with high-end vehicles, stylish interiors, and modern amenities. Fully air-conditioned luxury cabs ensure superior comfort and a smooth ride. Professional chauffeurs provide courteous service, punctual pickups, and safe driving, making this option ideal for business executives, corporate guests, couples, and travelers seeking a refined Pune to Mumbai journey."
  },
  {
    "name": "Corporate Cab Mumbai",
    "description": "Corporate Cab Mumbai is designed for business professionals and corporate groups traveling between Pune and Mumbai. Comfortable, air-conditioned cabs with professional chauffeurs ensure timely arrivals for meetings, conferences, and office travel. This service emphasizes professionalism, punctuality, safety, and comfort, making it ideal for regular corporate commuting and executive travel."
  },
  {
    "name": "Family Cab Mumbai",
    "description": "Family Cab Mumbai is perfect for families traveling together from Pune to Mumbai. Spacious vehicles with air-conditioning, comfortable seating, and sufficient luggage space ensure a pleasant journey for all age groups. Experienced drivers prioritize safety and smooth driving, making this service ideal for family visits, vacations, and special occasions."
  },
  {
    "name": "Airport Cab Pune to Mumbai",
    "description": "Airport Cab Pune to Mumbai provides a reliable and stress-free transfer service to Mumbai Airport. Fully air-conditioned cabs with ample luggage space ensure comfort during airport travel. Professional chauffeurs track flight timings, manage traffic efficiently, and ensure timely drop-offs or pickups. Ideal for business travelers, tourists, and families requiring dependable airport transfers."
  },
  {
    "name": "Affordable Cab Mumbai",
    "description": "Affordable Cab Mumbai offers budget-friendly travel options without compromising comfort or safety. Well-maintained, air-conditioned cabs with experienced drivers ensure a smooth journey at economical rates. Ideal for students, families, and group travelers, this service balances affordability, reliability, and convenience for Pune to Mumbai travel."
  },
  {
    "name": "Chauffeur Driven Cab Mumbai",
    "description": "Chauffeur Driven Cab Mumbai ensures a hassle-free journey with professional drivers handling navigation, traffic, and highway driving. Spacious, air-conditioned vehicles allow passengers to relax throughout the trip. Suitable for families, tourists, and corporate travelers, this service focuses on safety, comfort, and punctuality."
  },
  {
    "name": "Best Cab Pune to Mumbai",
    "description": "Best Cab Pune to Mumbai delivers a premium and dependable travel experience with well-maintained vehicles and trained chauffeurs. Fully air-conditioned cabs provide comfort on short and long journeys alike. Ideal for business travel, family trips, and airport transfers, this service ensures reliability, convenience, and customer satisfaction."
  },
  {
    "name": "Pune Mumbai Taxi",
    "description": "Pune Mumbai Taxi is a trusted choice for frequent travelers commuting between the two cities. Comfortable, air-conditioned taxis with experienced drivers offer safety, flexibility, and punctual service. Suitable for families, corporate travelers, and tourists, this service ensures a smooth and efficient road journey."
  },
  {
    "name": "One Way Cab Mumbai",
    "description": "One Way Cab Mumbai is an economical and convenient option for travelers who only need a single trip from Pune to Mumbai. Fully air-conditioned vehicles with professional chauffeurs ensure a comfortable and timely journey. Ideal for business travelers, tourists, and families seeking flexible one-way travel solutions."
  },
  {
    "name": "Round Trip Cab Mumbai",
    "description": "Round Trip Cab Mumbai is ideal for travelers planning to return to Pune after visiting Mumbai. Comfortable, air-conditioned vehicles with experienced chauffeurs ensure a smooth and safe round journey. Perfect for business travel, family visits, or short vacations, this service provides flexibility, reliability, and value."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows travelers to easily book Pune to Mumbai cabs anytime, anywhere. Customers can choose vehicle type, pickup and drop locations, travel date, and trip type with instant confirmation. Fully air-conditioned cabs with professional chauffeurs ensure a smooth, safe, and reliable journey with maximum booking convenience."
  },
  {
    "name": "Mumbai Travel Cab",
    "description": "Mumbai Travel Cab offers a comfortable and dependable road travel solution from Pune to Mumbai. Air-conditioned, well-maintained vehicles with spacious seating ensure a relaxing journey. Experienced chauffeurs handle traffic and routes efficiently, making this service suitable for tourists, families, and corporate travelers."
  }
],
"tableData": [
  ["Pune to Mumbai Cab Service", "Mumbai Cab from Pune"],
  ["AC Cab Pune to Mumbai", "Luxury Cab Mumbai Trip"],
  ["Corporate Cab Mumbai", "Family Cab Mumbai"],
  ["Airport Cab Pune to Mumbai", "Affordable Cab Mumbai"],
  ["Chauffeur Driven Cab Mumbai", "Best Cab Pune to Mumbai"],
  ["Pune Mumbai Taxi", "One Way Cab Mumbai"],
  ["Round Trip Cab Mumbai", "Online Cab Booking Pune"],
  ["Mumbai Travel Cab", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Cab Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services from Pune to Mumbai, ideal for airport transfers, business travel, family trips, and outstation journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to enjoy a smooth and relaxing journey from Pune to Mumbai."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and experienced on the Pune–Mumbai route, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Mumbai cab services, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Cab Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages based on your Pune to Mumbai travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Mumbai cab service."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services from Pune to Mumbai?',
    answer: 'Yes, Sanavi Travels offers comfortable and reliable cab services from Pune to Mumbai.'
  },
  {
    question: 'How can I book a Pune to Mumbai cab?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Pune to Mumbai travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for the Pune to Mumbai journey.'
  },
  {
    question: 'Are drivers experienced for the Pune–Mumbai route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Pune to Mumbai route.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup in Pune and drop-off anywhere in Mumbai.'
  },
  {
    question: 'Is the Pune to Mumbai cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services to match your travel schedule.'
  },
  {
    question: 'Are vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Mumbai trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'Booked a Pune to Mumbai cab with Sanavi Travels. Very comfortable ride, on-time pickup, and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Shah',
    feedback: 'Excellent service! Clean cab, smooth journey, and great customer support. Highly recommend Sanavi Travels.',
    rating: 5
  }
];


























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab Service - Sanavi Travels",
  "description": "Book Pune to Mumbai cabs with Sanavi Travels. AC and luxury cabs for family trips, corporate travel, airport transfers, one-way or round trips, and comfortable chauffeur-driven journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};








  return (
    <div>
<Helmet>
  <title>
    Pune to Mumbai Cab Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Mumbai with Sanavi Travels. Perfect for family trips, corporate travel, airport transfers, one-way or round trips, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaicabservice;